<template>
    <div id="accept-subscription-modals">
        <create-password-reminder-modal
            v-if="!subscriptionWasRecentlyAccepted && !passwordHasBeenUpdated && !showProvisionalPasswordForm"
            :plan="plan"
            @createPasswordButtonPressed="openUpdatePasswordModal"
        >
        </create-password-reminder-modal>
        <provisional-password-form-modal
            v-if="!passwordHasBeenUpdated && (subscriptionWasRecentlyAccepted || showProvisionalPasswordForm)"
            @passwordHasBeenUpdatedEvent="passwordHasBeenUpdatedListener"
        ></provisional-password-form-modal>
        <password-successfully-created-modal v-if="passwordHasBeenUpdated" :user-name="userName">
        </password-successfully-created-modal>
    </div>
</template>

<script>
import moment from 'moment';
import CreatePasswordReminderModal from './CreatePasswordReminderModal';
import PasswordSuccessfullyCreatedModal from './PasswordSuccessfullyCreatedModal';
import ProvisionalPasswordFormModal from './ProvisionalPasswordFormModal';

export default {
    components: {
        CreatePasswordReminderModal,
        PasswordSuccessfullyCreatedModal,
        ProvisionalPasswordFormModal,
    },

    props: {
        subscriptionWasRecentlyAccepted: Boolean,
        userName: String,
    },

    data() {
        return {
            showProvisionalPasswordForm: false,
            passwordHasBeenUpdated: false,
            passwordReminderOverflow: false,
            passwordUpdatedOverflow: false,
        };
    },

    methods: {
        passwordHasBeenUpdatedListener() {
            this.passwordHasBeenUpdated = true;
        },
        openUpdatePasswordModal() {
            this.showProvisionalPasswordForm = true;
        },
    },
};
</script>
